import React from "react";

import logo from "../assets/images/logo.png";
import MetamaskIcon from "../assets/images/MetamaskIcon.png";
import $ from "jquery";
import { click } from "@testing-library/user-event/dist/click";
import {useTranslation} from "react-i18next";


const Header = ({ getUserWallet, wallet }) => {
  const [ t ] = useTranslation(['home']);
  return (
    <header>
      <div className="navbar-black">
        <nav className="navbar navbar-expand-lg  ">
          <a className="navbar-brand" href="">
            <img className="mt-2" src={logo} width="100" alt="" />
          </a>
          {/*<button className="navbar-toggler" type="button" data-bs-toggle="collapse"*/}
          {/*        data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false"*/}
          {/*        aria-label="Toggle navigation">*/}
          {/*    <span className="navbar-toggler-icon" ></span>*/}
          {/*</button>*/}{" "}
          <div
            className="header__hamburguer navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
            id="MenuHamburguer"
          ></div>
          <div className="collapse    navbar-collapse" id="navbarNav">
            <ul
              className="navbar-nav"
              data-toggle="collapse"
              data-target=".navbar-collapse.show"
            >
              <li className="nav-item">
                <a className="nav-link mt-2" href="#">
                  {/*INICIO*/}
                  {t("home")}
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link mt-2" href="#NFTsSection">
                  MINT
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link mt-2" href="#randomizador">
                  {t("discoverAllNfts")}
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link mt-2" href="#FAQSection">
                  FAQ
                </a>
              </li>

              <li className="nav-item">
                <div
                  onClick={() => getUserWallet()}
                  className="btn-native-child user-button conect-button "
                >
                  <div className="header__user-icon">
                    <img src={MetamaskIcon}></img>
                  </div>
                  {wallet ? (
                    <span className="userWallet"> {wallet}</span>
                  ) : (
                    <span> {t("connectWallet")}</span>
                  )}
                </div>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
};
$(function () {
  $(document).scroll(function () {
    var $nav = $(".navbar-black");
    $nav.toggleClass("scrolled", $(this).scrollTop() > $nav.height());
  });
  $("#MenuHamburguer").click(() => {
    $("#MenuHamburguer").toggleClass("opened-menu");
  });
  $(".nav-link").click(() => {
    $("#navbarNav").removeClass("show");
    $("#MenuHamburguer").toggleClass("opened-menu");
  });
});

export default Header;

//
// import React from "react";
// import logo from  "../assets/images/logo.png"
// import MetamaskIcon from "../assets/images/MetamaskIcon.png"
// import $ from 'jquery';

//
// const Header = () => {
//     return (
//         <header>
//             <nav className="header__wrapper">
//                 <div className="header__hamburguer" id="MenuHamburguer"></div>
//                 <a className="header__logo" href="/"><img className="mt-2" src={logo} width="100"  alt=""/></a>
//                 <div className="header__menu" id="navbarNav">
//                     <ul className="header__menu-wrapper">
//                         <li className="nav-item">
//                             <a className="header-menu-link" href="/">INICIO</a>
//                         </li>
//                         <li className="nav-item">
//                             <a className="header-menu-link" href="#NFTsSection">NFTS</a>
//                         </li>
//                         <li className="nav-item">
//                             <a className="header-menu-link" href="#MuseumSection">MUSEO</a>
//                         </li>
//                         <li className="nav-item">
//                             <a className="header-menu-link" href="#FAQSection">FAQ</a>
//                         </li>
//                         <li className="nav-item">
//                             <a target="_blank" className="header-menu-link" href="https://racksmafia.com">TIENDA</a>
//                         </li>
//                     </ul>
//                     <div className="btn-native-child user-button conect-button">
//                         <div className="header__user-icon">
//                             <img src={MetamaskIcon}></img>
//                         </div>
//                         conectar cartera
//                     </div>
//                 </div>
//             </nav>
//         </header>
//     );
// };
// $(function () {
//
//     $('.logged-button').css('display', 'none')
//
//     $('.conect-button').click((e)=>{
//         e.preventDefault();
//
//         setTimeout(function(){
//             $('.conect-button').css('display', 'none')
//             $('.logged-button').css('display', 'block')
//         } , 22000)
//     })
//
//     $(document).scroll(function () {
//         var $nav = $(".navbar-black");
//         $nav.toggleClass('scrolled', $(this).scrollTop() > $nav.height());
//     });
//
//
//
//
//     //Menu Behaviour
//     $('#MenuHamburguer').click(()=>{
//         $('#MenuHamburguer').toggleClass('opened-menu')
//     })
// });
//
// export default Header;
